import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ManagedFlowStep {
  data: {
    cartIdFound: boolean,
  };
}

const initialState: ManagedFlowStep = {
  data: {
    cartIdFound: false,
  },
};

export const managedflowSlice = createSlice({
  name: 'managedFlowStep',
  initialState,
  reducers: {
    existingCartId: (state, action: PayloadAction<boolean>) => {
      state.data.cartIdFound = action.payload;
    },
  },
});

export const {
  existingCartId
} = managedflowSlice.actions;

export default managedflowSlice.reducer;
